<template>
  <div id="order-confirm">
    <SubTitle>融资信息</SubTitle>
    <Form
      v-model="applyFormData"
      class="order-confirm-form"
      ref="applyForm"
      :formField="getApplyFormField"
      :formRules="getApplyValidateOption"
      :formSelectorMap="applyFormSelectorMap"
      labelWidth="350px"
    />
    <SubTitle>产品信息</SubTitle>
    <Form
      v-model="productFormData"
      class="order-confirm-form"
      ref="productForm"
      :formField="getProductFormField"
      :formRules="getProductValidateOption"
      :formSelectorMap="applyFormSelectorMap"
      labelWidth="350px"
    />

    <div class="order-confirm__auth-box">
      <template v-if="version === 0">
        <el-checkbox v-model="isAgree">
          <span>我已阅读并同意</span>
          <span class="order-confirm__auth-link" @click.prevent="onAuthLinkClick">《授权书》</span>
          <span>，同意银行查询本人及企业信息</span>
        </el-checkbox>
      </template>
      <el-button class="order-confirm__auth-box__btn" type="primary" @click="onConfirm"
        >提 交</el-button
      >
    </div>

    <el-dialog top="30px" :visible="dialogControl === 'authDialog'" @close="onCloseAuth">
      <Authorization :companyName="applyFormData.enterpriseName" :uniscid="applyFormData.uniscid" />
    </el-dialog>

    <el-dialog
      :visible="dialogControl === 'isLimitDialog'"
      @close="handleCancelCountdown"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="wanning-dialog">
        <div class="wanning-dialog__icon-container">
          <i class="el-icon-warning"></i>
        </div>
        <div class="wanning-dialog__title">无法完成操作</div>
        <div class="wanning-dialog__reason">
          <div>您提交的产品已超过5个，请耐心等待银行审核。</div>
        </div>
        <div>
          <el-button class="wanning-dialog__btn" @click="gotoMyLoan" type="primary"
          >查看 "我的贷款" ({{ countdown }}s)</el-button
          >
        </div>
      </div>
    </el-dialog>
    <QrcodeDialog
      :preText="`订单已保存 \r\n 后续业务操作请在浙里办APP-浙里掌上贷完成。`"
      subText="请用浙里办APP扫码进行人脸识别"
      :qrcodeUrl="qrcodeUrl"
      :isShowDialog="isShowQrcodeDialog"
      @closeDialog="onCloseApplyQrcodeDialog"
    />
  </div>
</template>

<script>
import Form from '@/components/Form/index.vue'
import SubTitle from '@/components/SubTitle'
import QrcodeDialog from '@/components/QrcodeDialog'
import Authorization from '@/views/Authorization'

import {
  getApplyDeadline,
  getFinancType,
  getGuaranteeMeans,
  getFullAreaList,
  getApplicantEnterpriseRelationship,
  getFormatedBranchBankList,
  matchMultiFilterCondition
} from '@/utils/getSelectList'
import loading from '@/features/loadingOperate'

import {
  applyFormLegalField,
  applyFormPersonField,
  applyFormField,
  productFormField
} from './orderConfirmFormField'
import {
  applyFormLegalValidate,
  applyFormPersonValidate,
  applyFormValidate,
  productFormValidate,
  validateApplySituation
} from './orderConfirmFormValidate'
import { filterProductDetail } from './orderConfirmFormFilter'

import Order from '@/mixins/Order'
import { judgeIsGrayOrg } from '@/api/bank'
import { createQRcode } from '@/utils/tool'
import { getCurEnvH5Url } from '@/config/index'
import { mapState, mapActions } from 'vuex'

const COUNT_DOWN_TIMES = 5

export default {
  components: {
    Form,
    SubTitle,
    QrcodeDialog,
    Authorization
  },
  props: {
    productDetail: Object
  },
  mixins: [Order],
  data() {
    return {
      applyFormData: {
        //   个人字段
        enterpriseName: '',
        uniscid: '',
        applicantEnterpriseRelationship: '',
        hasJointApplicant: '',
        jointApplicantName: '',
        jointApplicantCardNo: '',
        jointApplicantMobile: '',
        autoRelationship: false,
        //
        contactName: '',
        contactPhone: '',
        businessLocation: [],
        operateArea: '',
        applyFinancingAmount: '',
        termRange: '',
        timeLimit: '',
        financingCategory: '',
        loanUse: '',
        guaranteeMeans: [],
        // 企业类型
        enterpriseForm: ''
      },
      isAgree: false,
      readAuthFile: false,
      productFormData: {},
      initReady: false,
      countdown: 0,
      countdownTimer: null,
      dialogControl: false,
      isShowQrcodeDialog: false,
      version: 1,
      qrcodeUrl: ''
    }
  },
  created() {},
  async mounted() {
    this.initApplyFormData()
    this.initProductFormData()

    //  法人用户可以提前获取到 uniscid 校验
    if (!this.isPerson) {
      this.judgeIsAllowedSubmitApply()
    }
    await this.$_orderMixin_judgeIsGetHistoryEnterpriseAddressInfo({
      form: this.applyFormData,
      locationKeyName: 'businessLocation',
      locationDetailKeyName: 'operateArea',
      enterpriseName: ''
    })
    this.getBranchBankList_vm()
    this.$nextTick(() => {
      this.initReady = true
    })
  },
  beforeDestroy() {
    clearInterval(this.countdownTimer)
  },
  watch: {
    isPerson: {
      immediate: true,
      handler(newVal) {
        if (!newVal) return
        this.applyFormData.isPerson = true
        this.productFormData.isPerson = true
      }
    },
    'applyFormData.enterpriseName'(newVal) {
      if (!this.initReady) return
      if (!newVal) {
        this.applyFormData.uniscid = ''
        return
      }
      this.getUniscidByName({ name: newVal })
        .then(async res => {
          const { data, code } = res
          if (code === 4002) {
            await this.$store.dispatch('user/getUserToken')
            return
          }
          this.applyFormData.uniscid = data && data.uniscid
          this.applyFormData.enterpriseForm = data && data.reportType

          if (!data) return
          // 根据获取到的统一码判断当前个人所输入的企业订单是否超过 5 笔
          this.judgeIsAllowedSubmitApply()
        })
        .catch(() => {
          this.applyFormData.uniscid = ''
        })
    },
    'applyFormData.businessLocation'(newVal) {
      if (!this.initReady) return
      this.getBranchBankList_vm()
      this.cleanOrgSelect()
    },
    'applyFormData.uniscid'(newVal) {
      if (!this.initReady) return
      //   用于判断机构选择器是否禁用
      this.productFormData.uniscid = newVal
      if (!newVal) {
        this.applyFormData.applicantEnterpriseRelationship = []
        this.applyFormData.autoRelationship = false
        return
      }
      this.getUserRelationship({ uniscid: newVal, cardNo: this.userInfo.idnum }).then(res => {
        const { data, code } = res
        if (code === 4002) {
          this.$store.dispatch('user/getUserToken')
          return
        }
        this.applyFormData.applicantEnterpriseRelationship = data ? data.split(',') : []
        this.applyFormData.autoRelationship = !!data
      })
    },
    'productFormData.curSelectedOrg'(branchBankId) {
      if (!branchBankId) return
      judgeIsGrayOrg({ id: branchBankId }).then(res => {
        if (res.data.code !== 0) return
        this.version = +res.data.data
      })
    }
  },
  methods: {
    // 订单信息初始化
    async initApplyFormData() {
      this.applyFormData = {
        ...this.applyFormData
        // businessLocation: this.$store.getters['user/getCityDistrictId']
      }
      // 个人用户 自动代入字段
      if (this.isPerson) {
        await this.$store.dispatch('user/getUserInfo')
        this.applyFormData.contactName = this.applyFormData.contactName || this.userInfo.username
        this.applyFormData.contactPhone = this.applyFormData.contactPhone || this.userInfo.mobile
      } else {
        this.applyFormData.enterpriseName = this.userInfo?.companyName
        this.applyFormData.uniscid = this.userInfo?.uniscid
      }
    },
    // 产品信息初始化
    initProductFormData() {
      this.productFormData = {
        ...this.productFormData,
        curSelectedOrg: '',
        uniscid: '',
        ...filterProductDetail(this.productDetail)
      }
    },
    getBranchBankList_vm() {
      const districtId = this.applyFormData.businessLocation[1]
      const bankId = this.productDetail.branchBankId
      this.$store
        .dispatch('bank/getBranchBankList', {
          bankId,
          districtId,
          productId: this.productDetail.id,
          // 科技积分贷 请求不同的支行列表
          type: this.productDetail.labelList.indexOf('科技积分贷') > -1 ? 0 : 1
        })
        .then(({ code }) => {
          if (code === 1 && !districtId) {
            this.$notify.warning({
              title: '注意',
              message: '填写订单前，请先选择地区'
            })
          }
        })
    },
    // 切换支行时，清空表单中的机构选择
    cleanOrgSelect() {
      this.productFormData.curSelectedOrg = ''
    },
    async onConfirm() {
      // TODO 新旧流程判断
      if (this.version === 0) {
        //  校验授权书阅读情况
        if (!this.isAgree || !this.readAuthFile) {
          return this.$notify.warning({ title: '注意', message: '请阅读并同意授权' })
        }
      }
      // 基础表单校验
      let validateResult = await Promise.all([
        this.$refs.applyForm.validate(),
        this.$refs.productForm.validate()
      ])
        .then(() => Promise.resolve(true))
        .catch(() => Promise.resolve(false))
      if (!validateResult) {
        return this.$notify.warning({ title: '注意', message: '请检查表单是否填写正确' })
      }
      //   校验填写的融资信息和产品的匹配情况
      validateResult = validateApplySituation(this.productDetail, this.applyFormData)
      if (validateResult !== true) {
        return this.$alert(validateResult, '注意', { confirmButtonText: '确定' })
      }
      // 大额提醒
      let confirmResult = await this.amountExcessConfirm(this.applyFormData)
      if (!confirmResult) return

      // TODO 新旧流程判断
      this.applyFormData.version = this.version

      const applyId = await this.submitApply()
      if (!applyId) return

      if (this.version === 0) {
        this.$router.push({
          path: '/submit-success',
          query: {
            applyId
          }
        })
      } else {
        this.createApplyQrcode(applyId)
      }
    },
    async createApplyQrcode(applyId) {
      let url = getCurEnvH5Url()
      url += `/loan/?applyId=${applyId}`
      this.qrcodeUrl = (await createQRcode(url)) || ''
      this.isShowQrcodeDialog = true
    },
    // 提交订单最终步骤
    async submitApply() {
      let form = this.filterFormData(this.getAllFormData())
      //  5笔校验
      if (this.version === 0) {
        await this.judgeIsAllowedSubmitApply()
      }

      loading.show(this, { target: '#order-confirm', fullscreen: false })

      //   const repeatCheckResult = await this.judgeRepeatOrderCheck(form)
      //   if (!repeatCheckResult) return

      const submitResult = this.submitOrder(form)
        .then(res => {
          const { code, data = {}, msg } = res.data
          if (code === 0) {
            this.$matomoTrackEvent('融资订单', '订单提交结果', '订单保存成功')
            return data.applyId
          } else {
            this.$matomoTrackEvent('融资订单', '订单提交结果', `订单保存失败：${msg}`)
            this.$message.error(msg)
            return false
          }
        })
        .catch(() => false)
        .finally(() => loading.close())

      return submitResult
    },

    // 从 form key 中提取数据 过滤无用数据 进行校验
    filterFormData(form) {
      return {
        version: form.version,
        enterpriseName: form.enterpriseName,
        contactName: form.contactName,
        contactPhone: form.contactPhone,
        cardNo: form.cardNo,
        uniscid: form.uniscid,
        enterpriseForm: form.enterpriseForm,
        productId: this.productDetail.id,
        // 个人
        // 黑名单写死 默认能提交订单的均不在黑名单内
        discredit: false,
        autoRelationship: form.autoRelationship,
        applicantEnterpriseRelationship: this.getApplicantEnterpriseRelationshipNames(form),
        hasJointApplicant: +form.hasJointApplicant === 1,
        loanType: this.isPerson ? 1 : 0,
        jointApplicantName: form.jointApplicantName,
        jointApplicantCardNo: form.jointApplicantCardNo,
        jointApplicantMobile: form.jointApplicantMobile,
        //
        operateArea: form.operateArea,
        applyFinancingCategory: form.financingCategory || null,
        applyLoanUse: form.loanUse,
        applyFinancingAmount: form.applyFinancingAmount,
        applyGuaranteeMeanIds: form.guaranteeMeans.sort().join(','),
        enterpriseCityId: form.businessLocation[0],
        enterpriseDistrictId: form.businessLocation[1],
        applyTermRangeId: form.termRange,
        applyTimeLimit: Number(form.termRange) === -1 ? form.timeLimit : '',
        branchBankId: form.curSelectedOrg,
        branchBankName: this.branchBankSelectorList.find(org => org.id === form.curSelectedOrg)
          .name,
        applyPlatform: Number(sessionStorage.getItem('applyPlatform')) || 0,
        appEntrance: '网上贷'
      }
    },
    // 重复订单校验
    async judgeRepeatOrderCheck(form) {
      const repeatStatus = await this.repeatOrderCheck(form).catch(() => Promise.resolve(false))

      switch (String(repeatStatus)) {
        case '0':
          return Promise.resolve(true)
        case '1':
          this.$router.push('/my/loan')
          return Promise.resolve(false)
        case '2':
          return this.$confirm('您已提交此产品订单，是否再次提交', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => Promise.resolve(true))
            .catch(() => Promise.resolve(false))
        default:
          return Promise.resolve(false)
      }
    },
    amountExcessConfirm(form) {
      if (form.applyFinancingAmount < 10000) return true
      let amount = (form.applyFinancingAmount / 10000 + 0.0001).toFixed(2)
      return new Promise((resolve, reject) => {
        this.$confirm(`注意，您输入的融资金额已达：${amount}亿元，请确认是否继续提交`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            resolve(true)
          })
          .catch(() => {
            resolve(false)
          })
      })
    },
    handleCancelCountdown() {
      this.dialogControl = false
      this.countdown = 0
      this.gotoMyLoan()
    },
    async judgeIsAllowedSubmitApply() {
      if (!this.userInfo) {
        await this.$store.dispatch('user/getUserInfo')
      }
      const uniscid = this.userInfo.uniscid || this.applyFormData.uniscid
      let isApplyLimit = await this.getIsApplyLimit(uniscid)
      if (isApplyLimit) {
        this.handleApplyLimit()
        throw new Error()
      }
    },
    // 超过 5 笔限制
    handleApplyLimit() {
      this.dialogControl = 'isLimitDialog'
      if (this.countdown <= 0) {
        this.countdown = COUNT_DOWN_TIMES
        this.countdownTimer = setInterval(() => {
          this.countdown--
          if (this.countdown <= 0) {
            this.gotoMyLoan()
          }
        }, 1000)
      }
    },
    gotoMyLoan() {
      this.$router.push('/my/loan')
    },
    getApplicantEnterpriseRelationshipNames(form) {
      if (!this.isPerson) return
      // 非自动带入时
      if (!form.autoRelationship) {
        let idsStr = form.applicantEnterpriseRelationship.join(',')
        let namesArr = matchMultiFilterCondition(idsStr, '申请人与企业关联关系', this.listCondition)
        return namesArr && namesArr.map(item => item.name).join('、')
      } else {
        // 自动带入时
        return form.applicantEnterpriseRelationship.join('、')
      }
    },
    onCloseAuth() {
      this.dialogControl = false
    },
    onAuthLinkClick(e) {
      this.isAgree = true
      this.readAuthFile = true
      this.dialogControl = 'authDialog'
    },
    getAllFormData() {
      return {
        ...this.applyFormData,
        curSelectedOrg: this.productFormData.curSelectedOrg
      }
    },
    onCloseApplyQrcodeDialog() {
      this.isShowQrcodeDialog = false
      this.gotoMyLoan()
    },
    ...mapActions('user', ['getUniscidByName', 'getUserRelationship', 'getUserDishonestyInfo']),
    ...mapActions('loan', ['submitOrder', 'repeatOrderCheck', 'getIsApplyLimit'])
  },
  computed: {
    isPerson() {
      return this.$store.state.user.userType === '个人'
    },
    getApplyFormField() {
      console.log([...applyFormLegalField, ...applyFormField])
      return this.isPerson
        ? [...applyFormPersonField, ...applyFormField]
        : [...applyFormLegalField, ...applyFormField]
    },
    getProductFormField() {
      const form = productFormField
      form.forEach((item) => {
        if (item.prop === 'annualInterestRange') {
          item.label = this.productDetail.interestRateTypeName || '年息范围'
        }
      })
      return form
    },
    getApplyValidateOption() {
      return this.isPerson
        ? { ...applyFormPersonValidate, ...applyFormValidate }
        : { ...applyFormLegalValidate, ...applyFormValidate }
    },
    getProductValidateOption() {
      return productFormValidate
    },
    // 表单选择器选项集合
    applyFormSelectorMap() {
      return {
        fullAreaSelectorList: getFullAreaList(this.$store.state.area.fullAreaList),
        applyDeadlineSelectorList: this.applyDeadlineSelectorList,
        financTypeSelectorList: this.financTypeSelectorList,
        guaranteeMeansSelectorList: this.guaranteeMeansSelectorList,
        branchBankSelectorList: this.branchBankSelectorList,
        relationshipSelectorList: this.getRelationshipSelectorList,
        hasJointApplicantSelectorList: [{ id: '1', name: '是' }, { id: '2', name: '否' }]
      }
    },
    // 融资期限
    applyDeadlineSelectorList() {
      return getApplyDeadline(this.listCondition).filter(item => {
        if (item.name === '手动填写') {
          return true
        } else if (item.name === '不限' || !item.ext) {
          return false
        }
        const ext = JSON.parse(item.ext)
        const isInScope =
          +ext.start < this.productDetail.termRangeEnd &&
          +ext.end >= this.productDetail.termRangeStart
        const isInInfinite = +ext.start > +ext.end && +ext.start < this.productDetail.termRangeEnd
        return isInScope || isInInfinite
      })
    },
    // 融资类型
    financTypeSelectorList() {
      return getFinancType(this.listCondition).filter(condition => {
        //  法人不展示个人经信贷选项
        if (!this.isPerson) {
          return (
            [this.productDetail.financingCategory].indexOf(condition.id) > -1 &&
            condition.id !== '119'
          )
        }
        return [this.productDetail.financingCategory].indexOf(condition.id) > -1
      })
    },
    // 担保方式
    guaranteeMeansSelectorList() {
      return getGuaranteeMeans(this.listCondition).filter(condition => {
        return !!condition.id && this.productDetail.guaranteeMeansList.indexOf(condition.name) > -1
      })
    },
    getRelationshipSelectorList() {
      return getApplicantEnterpriseRelationship(this.listCondition)
    },
    branchBankSelectorList() {
      return getFormatedBranchBankList(this.$store.state.bank.branchBankList)
    },
    ...mapState('user', {
      cityInfo: state => state.cityInfo,
      token: state => state.token,
      ticket: state => state.ticket,
      userInfo: state => state.userInfo
    }),
    ...mapState('product', {
      listCondition: state => state.listCondition
    })
  }
}
</script>

<style lang="scss" scoped>
.order-confirm-form {
  margin: 0 auto;
  max-width: 1000px;
}

.order-confirm__form {
  margin: 40px 0 50px;
}

.order-confirm__auth-box {
  max-width: 1000px;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-right: 92px;
  margin: 50px auto 0 auto;
  .order-confirm__auth-link {
    color: rgba(41, 84, 208, 1);
  }

  &__btn {
    width: 130px;
    height: 36px;
    background: rgba(41, 84, 208, 1);
    margin-right: 260px;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    margin-top: 50px;
    /deep/ .el-button {
      border-radius: 2px;
    }
  }
}

.wanning-dialog {
  &__icon-container {
    margin-bottom: 20px;
    i {
      font-size: 54px;
      color: #ffa007;
    }
  }
  &__title {
    font-size: 20px;
    margin-bottom: 15px;
  }
  &__reason {
    color: #999;
    font-size: 16px;
    margin-bottom: 30px;
    & span {
      margin: 0 3px;
      cursor: pointer;
      color: $main-color;
    }
  }
  &__btn {
    padding: 10px 16px;
    border-radius: 8px;
  }
}
</style>
